<template>
  <div>
    <div class="numul">
      <ul :class="types=='home'?'homeul':'lotteryul'">
        <li v-for="(item,index) in drawList" :key="index" class="blue">
          <img
            :src="_cdn + '/pc/images/bet/cqssc-icons/cqssc-icon-'+item+'.svg'"
            alt
          />
        </li>
      </ul>
    </div>
    <div class="smalltable" v-if="types=='home'">
      <table
        v-if="bigClass=='LHC'"
        cellpadding="0"
        cellspacing="0"
        border="0"
        style="width:100%;textAlign:center;border-top: solid 1px #e5e5e5;border-left: solid 1px #e5e5e5;"
      >
        <tr>
          <td
            style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846"
            height="30"
          >特码单双</td>
          <td
            style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846"
            height="30"
          >特码大小</td>
          <td
            style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846"
            height="30"
          >总和单双</td>
          <td
            style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846"
            height="30"
          >总和大小</td>
        </tr>
        <tr>
          <td
            style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;"
            height="30"
            v-for="(item,index) in drawingNumbertool"
            :key="index"
          >{{item}}</td>
        </tr>
      </table>
      <table
        v-else
        cellpadding="0"
        cellspacing="0"
        border="0"
        style="width:100%;textAlign:center;border-top: solid 1px #e5e5e5;border-left: solid 1px #e5e5e5;"
      >
        <tr>
          <td
            style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846"
            height="30"
            colspan="3"
          >总和</td>
          <td
            style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;color:#de0846"
            height="30"
          >龙虎</td>
        </tr>
        <tr>
          <td
            style="border-right: solid 1px #e5e5e5;border-bottom: solid 1px #e5e5e5;"
            width="105"
            height="30"
            v-for="(item,index) in drawingNumbertool"
            :key="index"
          >{{item}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import lotteryRandBall from "~/mixins/lotteryRandBall.mixins";
export default {
  mixins: [lotteryRandBall],
  props: {
    lotcode: {
      type: [String],
      default: null
    }
  },
  computed: {
    _cdn() {
      return this.$store.getters['service/cdn']
    },
    drawingNumbertool() {
      let { drawingNumber, bigClass } = this;
      if(drawingNumber.length<=1){
        drawingNumber = this.randList;
      }
      let tool = [];
      let add = drawingNumber.reduce((a, b) => a * 1 + b * 1);
      tool.push(add);
      if (add > 22) {
        tool.push("大");
      } else {
        tool.push("小");
      }
      if (add % 2 == 0) {
        tool.push("双");
      } else {
        tool.push("单");
      }
      if (drawingNumber[0] > drawingNumber[4]) {
        tool.push("龙");
      } else {
        tool.push("虎");
      }
      return tool;
    }
  }
};
</script>

<style lang="less" scoped>
.numul {
  display: flex;
  flex-wrap: nowrap;
  margin-top: 16px;
  height: 56px;
  .lotteryul {
    display: flex;
    .blue {
      width: 36px;
      height: 36px;
      line-height: 36px;
      border-radius: 18px;
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      background: url(../../assets/xuebitu.png) no-repeat -1px -47px !important;
      margin: 0 10px;
    }
  }
  .homeul {
    display: flex;
    .blue {
      width: 36px;
      height: 36px;
      line-height: 36px;
      border-radius: 18px;
      color: #fff;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      background: url(../../assets/xuebitu.png) no-repeat -1px -47px !important;
      margin: 0 2px;
    }
  }
}
</style>